


















import Element from '../../../mixins/element';
import { Component } from 'vue-property-decorator';

@Component
export default class Expiry extends Element {
    public cardExpiry: any;
    public toMount() {
        this.loading = true;
        this.cardExpiry = this.integrationData.elements.create('cardExpiry', {
            style: this.integrationStyles.styles,
            classes: this.integrationStyles.classes,
        });

        const id = this.$el.id || 'str3_' + Math.round(Math.random() * 10000);
        this.$el.id = '';
        (this.$refs.target as HTMLElement).id = id;
        this.cardExpiry.mount(`#${id}`);

        this.cardExpiry.on('ready', () => {
            this.loading = false;
        });

        this.cardExpiry.on('focus', () => {
            this.onFocus();
        });

        this.cardExpiry.on('blur', () => {
            this.onBlur();
        });

        this.cardExpiry.on('change', (data: any) => {
            const result: any = {
                ...data,
                isEmpty: data.empty,
            };
            delete result.empty;
            this.input = result;
        });
    }

    public toValidate(): boolean {
        return this.serializedData.complete || false;
    }

    public toClear() {
        this.cardExpiry.clear('cardCvc');
    }

    public toDestroy() {
        this.cardExpiry.destroy();
    }

    public toFocus(): void {
        this.cardExpiry.focus();
    }

    public toBlur(): void {
        this.cardExpiry.blur();
    }
}
